// extracted by mini-css-extract-plugin
module.exports = {"root":"login_root__2y2-G","wrap":"login_wrap__3FJDz","content":"login_content__3tIK3","logo":"login_logo__2nPAt","title":"login_title__27KlX"};